import { Flex, Form } from "antd"

import Icon from "../../Icon"
import ButtonComponent from "../Button"
import SelectComponent from "../Select"

function GenerateLinkForm({ onClose, onSubmit, options }) {
  const [form] = Form.useForm()

  const onFinish = (values) => {
    onSubmit(values)
  }

  function handleClearError(e, field) {
    form.setFields([
      {
        name: field,
        errors: []
      }
    ])
  }

  function onFocusHandler(e, fieldName) {
    const field = fieldName || e.target.name || e.target.id
    handleClearError(e, field)
  }

  const addErrorIcon = (error) => (
    <span>
      <Icon type={"alert_triangle_error"} /> {error}
    </span>
  )

  const validateMessages = {
    required: addErrorIcon("Required fields were not filled.")
  }

  return (
    <Form
      className={"with-default-error"}
      onFinish={onFinish}
      validateTrigger="onSubmit"
      validateMessages={validateMessages}
      layout="vertical"
      form={form}
    >
      <Form.Item name="source" label="Source" rules={[{ required: true }]}>
        <SelectComponent
          size="large"
          options={options?.["source"]}
          name="source"
          onFocus={onFocusHandler}
        />
      </Form.Item>

      <Form.Item name="campaign" label="Campaign" rules={[{ required: true }]}>
        <SelectComponent
          size="large"
          options={options?.["campaign"]}
          name="campaign"
          onFocus={onFocusHandler}
        />
      </Form.Item>
      <Flex gap={16} justify="end" style={{ padding: "0 3px 3px 3px" }}>
        <ButtonComponent size="large" htmlType="button" onClick={onClose}>
          Cancel
        </ButtonComponent>

        <ButtonComponent size="large" type="primary" htmlType="submit">
          Generate
        </ButtonComponent>
      </Flex>
    </Form>
  )
}

export default GenerateLinkForm
